import React from 'react'
import { PageTitle } from '../../../_metronic/layout/core'

export const Defaults = () => {
  return (
    <PageTitle>Defaults</PageTitle>
  )
}
